import { jsx as m } from "react/jsx-runtime";
import { c as a } from "../../../index-Cu0xwYjD.js";
import { s as o } from "../../../Grid.module-_d_yvtu8.js";
const h = 12, $ = ({
  children: i,
  className: c,
  style: e,
  span: r = h,
  small: l,
  medium: s,
  large: t,
  ...d
}) => /* @__PURE__ */ m(
  "div",
  {
    style: {
      "--el-col-width": `${r / 12 * 100}%`,
      "--el-col-width-small": l ? `${l / 12 * 100}%` : void 0,
      "--el-col-width-medium": s ? `${s / 12 * 100}%` : void 0,
      "--el-col-width-large": t ? `${t / 12 * 100}%` : void 0,
      ...e
    },
    className: a(o.col, {
      [o.small]: !!l,
      [o.medium]: !!s,
      [o.large]: !!t,
      className: c
    }),
    ...d,
    children: i
  }
);
export {
  $ as Col
};
